import React, { Component } from 'react';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import { Formik } from 'formik';
import { Form, FormGroup, InputGroup, Input, FormFeedback, Button } from 'reactstrap';
import * as Yup from 'yup';
class MailchimpForm extends Component {
  ValidationSchema = Yup.object().shape({
    FNAME: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    EMAIL: Yup.string()
      .email('Invalid email')
      .required('Required'),
  });
  constructor(props){
    super(props)
    this.state = {
      subscribe:'',
      errorMsg:''
    }
   // this.touchAll = this.touchAll.bind(this)
  }
  onSubmit = (values, { setSubmitting, setErrors }) => {

    this.props.onSubmitted(values)
    //this.setState({subscribe:'Subscribing now...'})
  }
  componentWillReceiveProps(nextProps){

    this.setState({subscribe: nextProps.sendingState, errorMsg: nextProps.errorMsg})
  }
  render (){

    return (
  <div>
    <Formik
      initialValues={{
        FNAME: '',
        EMAIL: '',
      }}
      validationSchema={this.ValidationSchema}
      onSubmit={this.onSubmit}
    >
      {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched}) => (
          <Form onSubmit={handleSubmit} noValidate name='subscribeForm'>
            <FormGroup className='mailchimp'>
            <InputGroup>
                <Input type="text"
                        name="FNAME"
                        id="FNAME"
                        placeholder="Full Name"
                        invalid={touched.FNAME && !!errors.FNAME}
                        autoFocus={false}
                        onChange={handleChange}
                        required
                        value={values.FNAME} />
                <div className="input-group-append">
                  <span className="input-group-text"><i className="fa fa-user"></i></span>
                </div>
                <FormFeedback>{errors.FNAME}</FormFeedback>
              </InputGroup>
              
            </FormGroup>          
            <FormGroup className='mailchimp'>
            <InputGroup>
                <Input type="email"
                        name="EMAIL"
                        id="EMAIL"
                        placeholder="Email"
                        // valid={!errors.email}
                        invalid={touched.EMAIL && !!errors.EMAIL}
                        autoFocus={false}
                        onChange={handleChange}
                        required
                        value={values.EMAIL} />
                <div className="input-group-append">
                  <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                </div>
                <FormFeedback>{errors.EMAIL}</FormFeedback>
              </InputGroup>
            </FormGroup>
            <FormGroup className={'mailchimp'}>
             { (this.state.subscribe === 'error')?<div style={{ color: "red" }} dangerouslySetInnerHTML={{__html: this.state.errorMsg}}/>
             :<div style={{color:"#4dbd74"}}>{this.state.errorMsg}</div> }
            </FormGroup>
            <FormGroup className='mailchimp'>
              <Button 
                // onClick={() => this.touchAll(setTouched, errors)} 
                type="submit" color="success" className="mr-1" style={{float:"right"}}>Subscribe</Button>
            </FormGroup>                       
          </Form>
      )}
    </Formik>
  </div>
);
}
}

export default () => (
  <MailchimpSubscribe
  url={"https://growjo.us20.list-manage.com/subscribe/post?u=3d5b446d5a91119be9bb3d330&id=82ceabf170"}
  render={({ subscribe, status, message }) => {
    return(
    <div>
      <MailchimpForm onSubmitted={formData => subscribe(formData)} sendingState={status} errorMsg = {message} />
      {/* {status === "sending" && <div style={{ color: "blue" }}>sending...</div>}
      {status === "error" && <div style={{ color: "red" }} dangerouslySetInnerHTML={{__html: message}}/>} */}
      {/* {status === "success" &&<div style={{position: "absolute", height: 100, width: 150, top: "50%", left: "50%", margin: "150px 0 0 -75px",backgroundColor:"red"}}>
      Subscribed !
      </div>} */}
    </div>
  )}}
/> 
)




// WEBPACK FOOTER //
// ./client/src/components/mailchimpForm.js